@let canCreateNotification = userContextService.canCreateCommunicationNotification();
@let canReadNotification = userContextService.canReadCommunicationNotification();
@let canUpdateNotification = userContextService.canUpdateCommunicationNotification();
@let canDeleteNotification = userContextService.canDeleteCommunicationNotification();

<div class="notification-list-page">
  <topo-data-table-server
    #table
    [isActive]="true"
    [tableHidden]="isTableLoading"
    [datasource]="datasource"
    [columns]="columDefs"
    headerLabel="{{ 'COMMUNICATIONS.NOTIFICATIONS' | translate }}"
    [newLabel]="'COMMUNICATIONS.NEW-NOTIFICATION' | translate"
    [headerIcon]="'assets/images/purple_bullhorn.svg'"
    [showNewButton]="canAddNotification && userContext?.hasPermission(Permissions.CommunicationNotificationCreate)"
    [showHeader]="true"
    [showSearch]="canReadNotification"
    [showMenu]="false"
    [autoFitColumns]="true"
    [getRowId]="getRowId"
    [showRowGroups]="false"
    [showSystemFields]="true"
    [enableInfiniteScroll]="false"
    [enableServerSort]="true"
    [enableServerFilter]="true"
    (paginate)="onPaginate($event)"
    (newClick)="newNotification()"
    (takeChanged)="onTakeChanged($event)"
    (storeUpdatedCalled)="onGridDataLoaded()"
    [skip]="skip"
    [take]="take"
  [totalCount]="totalCount"></topo-data-table-server>

  <topo-comms-new-notification></topo-comms-new-notification>
  <topo-confirm-delete
    [isActive]="!!notificationToDelete"
  (confirmResponse)="confirmDeleteNotification($event)"></topo-confirm-delete>

  <topo-comms-notification-edit></topo-comms-notification-edit>
  <topo-comms-notification-log
    [notification]="logNotification"
  (logClosed)="onLogClosed()"></topo-comms-notification-log>
</div>

@if (canReadNotification) {
  <div
    class="source-type"
    fxLayout="row"
    fxLayoutAlign="center center">
    <div class="type-header">{{ 'COMMUNICATIONS.COLUMNS.SOURCE' | translate }}</div>
    <div class="select is-small is-fullwidth">
      <select
        [(ngModel)]="selectedSourceType"
        (change)="sourceTypeChanged($event)">
        @for (source of sourceTypes; track source.value) {
          <option
            [ngValue]="source.value">
            {{ source.name }}
          </option>
        }
      </select>
    </div>
  </div>
}
